interface LanguageSettings {
  urlMatcher: string;
  translationKey: string;
  url: string;
}

export function getLanguageSettings(site: string): LanguageSettings[] | null {
  if (site === 'sunwebbefr') {
    return [
      {
        urlMatcher: '/fr',
        translationKey: 'language_french',
        url: '/fr',
      },
      {
        urlMatcher: '/nl',
        translationKey: 'language_netherlands',
        url: '/nl',
      },
    ];
  }

  if (site === 'sunwebbenl') {
    return [
      {
        urlMatcher: '/nl',
        translationKey: 'language_netherlands',
        url: '/nl',
      },
      {
        urlMatcher: '/fr',
        translationKey: 'language_french',
        url: '/fr',
      },
    ];
  }

  return null;
}
